/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Content\Offers\OfferFiles\OfferFilesRow.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Friday October 11th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday October 11th 2024 1:55:30 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { TableRow, TableCell, Switch, Button } from "@mui/material";
import { IoIosSave } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { OfferFileType } from "Type/offer.type";
import Styles from "Content/Offers/OfferFiles/OfferFileRow.module.css";
import { MouseEvent, useEffect, useState } from "react";
import OfferFileService from "Services/Offer/OfferFileService";
import { ModalConfirmRequest } from "Content/Modals/ModalConfirmRequest/ModalConfirmRequest";
import translator from "MultiLanguage/TranslationWrapper";

type OfferFileProps = {
    file: OfferFileType,
    changeFileCount: Function,
    removeFileRow: Function,
};

export default function OfferFilesRow(props: OfferFileProps) {
    const [shared, setShared] = useState(props.file.SharedToClient);
    const [disabled, setDisabled] = useState(false);
    const [openModal, setOpenModal] = useState<boolean>(false);

    useEffect(() => {
        setDisabled(shared !== props.file.SharedToClient);
    }, [shared]);

    const HandleCloseModal = () => {
        setOpenModal(false);
    };

    const HandleUpdateFile = () => {
        OfferFileService.updateSharedFile(props.file.id, shared).then((result) => {
            setDisabled(false);
        }).catch((error) => {
            console.error(error);
        });
    };

    const HandleDeleteFile = () => {
        OfferFileService.deleteFile(props.file.id).then((result) => {
            props.changeFileCount(1, true);
            props.removeFileRow(props.file.id);
        }).catch((error) => {
            console.error(error);
        });
    };

    return (
        <TableRow key={props.file.id}>
            <TableCell>
                <Button>
                    <a className={`${Styles.link}`} target={"_blank"} href={props.file.URI}>
                        {props.file.Name}
                    </a>
                </Button>
            </TableCell>
            <TableCell> <Switch checked={shared} onClick={() => setShared(!shared)} /> </TableCell>
            <TableCell>
                <div className={`${Styles.action}`}>
                    <Button disabled={!disabled} onClick={HandleUpdateFile}>
                        <IoIosSave size={"1.5rem"} />
                    </Button>
                    <Button onClick={() => setOpenModal(true)}>
                        <MdDelete color="red" size={"1.5rem"} />
                    </Button>
                </div>
            </TableCell>
            <ModalConfirmRequest show={openModal} onClose={HandleCloseModal} closeModal={HandleCloseModal} request={HandleDeleteFile} title={translator.decode("dynamic.confirm")} />
        </TableRow>
    );
}
